import { useDisasterStore } from '../../../stores/disasterStore'
import { useMiiaFwStore } from '@/stores/miiaFwStore'
import { useCommonModalStore } from '@/stores/commonModalStore'
import { useAeroUploadStore } from '@/stores/aeroUploadStore'
import { usePropertyTaxUploadStore } from '@/stores/propertyTaxUploadStore'
import { useGovernmentSettingStore } from '@/stores/governmentSettingStore'

export const useStoreUtils = () => {
  const commonModalStore = useCommonModalStore()
  const miiaFwStore = useMiiaFwStore()
  const disasterStore = useDisasterStore()
  const aeroUploadStore = useAeroUploadStore()
  const propertyTaxUploadStore = usePropertyTaxUploadStore()
  const governmentSettingStore = useGovernmentSettingStore()

  const allReset = () => {
    commonModalStore.reset()
    miiaFwStore.reset()
    disasterStore.reset()
    aeroUploadStore.reset()
    propertyTaxUploadStore.reset()
    governmentSettingStore.reset()
  }

  return {
    allReset
  }
}
